
import React from 'react'

const searchForm = (props) => (
  <form role='search' action={props.searchFormAction || '/search.html'} method='get'>
    <div className='input-group z0'>
      <label htmlFor={props.id || 'siteSearch'} className='sr-only'>Search our site</label>
      <input id={props.id || 'siteSearch'}className='form-control' name='search' type='text' placeholder={props.searchFormPlaceholder || 'Search Holiday Extras'} />
      <div className='input-group-btn'>
        <button className='btn btn-primary' type='submit'>
          <span className='sr-only'>{props.searchButtonText || 'Search'}</span> <span dangerouslySetInnerHTML={{ __html: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="14" viewBox="0 0 13 14"><path fill="#fff" d="M9 6.5q0-1.445-1.027-2.473t-2.473-1.027-2.473 1.027-1.027 2.473 1.027 2.473 2.473 1.027 2.473-1.027 1.027-2.473zM13 13q0 0.406-0.297 0.703t-0.703 0.297q-0.422 0-0.703-0.297l-2.68-2.672q-1.398 0.969-3.117 0.969-1.117 0-2.137-0.434t-1.758-1.172-1.172-1.758-0.434-2.137 0.434-2.137 1.172-1.758 1.758-1.172 2.137-0.434 2.137 0.434 1.758 1.172 1.172 1.758 0.434 2.137q0 1.719-0.969 3.117l2.68 2.68q0.289 0.289 0.289 0.703z"></path></svg>' }} />
        </button>
      </div>
    </div>
  </form>
)

export default searchForm
